<template>
	<div>
		<b-form-select
			v-model="type"
			:options="list_type"
			v-on:input="updateType" />
		<div v-if="type == 'db'">
			&nbsp;
			<b-form-select
				v-model="table"
				:options="tables"
				v-on:input="updateTable" />
		</div>
		<div v-if="type == 'fichier'">
			&nbsp;
			<fileset ref="set" @update="update"></fileset>
		</div>
		<div v-if="type == 'db' && table">
			<database
				:name="false"
				:edit="false"
				@update="update"
				ref="set"></database>
		</div>
		<div v-if="type == 'ensemble'">
			<ensemble :name="false" @update="update" ref="set"></ensemble>
		</div>
		<div>
			<br />
			<h5>
				Nom des colonnes
				<b-button
					style
					v-b-toggle="'collapse-dataset-' + dataset_id + id"
					><i v-if="collapse" class="fas fa-eye-slash"></i
					><i v-if="!collapse" class="fas fa-eye"></i
				></b-button>
			</h5>
			<b-collapse
				:id="'collapse-dataset-' + dataset_id + id"
				v-model="collapse"
				visible>
				<span>Prefix</span>
				<b-form-input v-model="prefix"></b-form-input>
				<b-button @click="add_prefix" :disabled="update_run"
					>Ajouter prefix</b-button
				>
				&nbsp;
				<b-button @click="reinitialize" :disabled="update_run"
					>Réinitialiser</b-button
				>
				<br /><br />
				<div v-for="column in columns" :key="column.name">
					<span>{{ column.name }}</span>
					<b-form-input
						v-model="column.new_name"
						@change="update_column($event, column)"></b-form-input>
				</div>
			</b-collapse>
		</div>
		<hr />
	</div>
</template>

<script>
	var clone = require("clone");
	import uniqueId from "lodash.uniqueid";

	import databaseView from "../views/database.vue";
	import fileset from "../components/fileset.vue";
	import database from "../services/database.js";
	import ensemble from "../views/Ensemble.vue";
	import users from "../services/users.js";

	export default {
		name: "dataset",
		components: {
			database: databaseView,
			fileset: fileset,
			ensemble: ensemble,
		},
		data() {
			return {
				data: [],
				type: "",
				list_type: ["fichier", "db", "ensemble"],
				tables: [],
				table: "",
				columns: [],
				columns_name: [],
				collapse: false,
				prefix: "",
				update_run: false,
				id: uniqueId(""),
			};
		},
		props: ["dataset_id"],
		methods: {
			save() {
				return {
					type: this.type,
					table: this.table,
					columns: this.columns,
					columns_name: this.columns_name,
					set: this.$refs.set.save(),
				};
			},
			async load(data) {
				var self = this;

				//(data)

				this.type = data.type;
				this.table = data.table;
				this.columns = data.columns;
				this.columns_name = data.columns_name;

				await new Promise((resolve, reject) => {
					self.$nextTick(async function () {
						if (self.type == "db")
							await self.$refs.set.init(self.table);
						await self.$refs.set.load(data.set);
						resolve();
					});
				});
			},
			async add_prefix() {
				this.update_run = true;
				for (var j = 0; j < this.columns.length; j++) {
					var column = this.columns[j];
					column.new_name = this.prefix + column.new_name;
					for (var i = 0; i < this.data.length; i++) {
						if (this.data[i].hasOwnProperty(column.intermediate)) {
							this.data[i][column.new_name] =
								this.data[i][column.intermediate];
							delete this.data[i][column.intermediate];
						}
					}
					column.intermediate = column.new_name;
				}
				await this.update();
				this.update_run = false;
			},
			async update_column(event, column) {
				this.update_run = true;
				for (var i = 0; i < this.data.length; i++) {
					if (this.data[i].hasOwnProperty(column.intermediate)) {
						this.data[i][column.new_name] =
							this.data[i][column.intermediate];
						delete this.data[i][column.intermediate];
					}
				}
				column.intermediate = column.new_name;
				await this.update();
				this.update_run = false;
			},
			async add_prefix() {
				this.update_run = true;
				for (var j = 0; j < this.columns.length; j++) {
					var column = this.columns[j];
					column.new_name = this.prefix + column.new_name;
					for (var i = 0; i < this.data.length; i++) {
						if (this.data[i].hasOwnProperty(column.intermediate)) {
							this.data[i][column.new_name] =
								this.data[i][column.intermediate];
							delete this.data[i][column.intermediate];
						}
					}
					column.intermediate = column.new_name;
				}
				await this.update();
				this.update_run = false;
			},
			async reinitialize() {
				this.update_run = true;
				for (var j = 0; j < this.columns.length; j++) {
					var column = this.columns[j];
					column.new_name = column.name;
					for (var i = 0; i < this.data.length; i++) {
						if (this.data[i].hasOwnProperty(column.intermediate)) {
							this.data[i][column.new_name] =
								this.data[i][column.intermediate];
							delete this.data[i][column.intermediate];
						}
					}
					column.intermediate = column.new_name;
				}
				this.update();
				this.update_run = false;
			},
			async update(data) {
				//console.log("update dataset")
				if (data) {
					this.data = clone(data);
					if (this.data.length > 0) {
						var keys = Object.keys(this.data[0]);
						for (var i = 0; i < keys.length; i++) {
							if (!this.columns_name.includes(keys[i])) {
								this.columns_name.push(keys[i]);
								this.columns.push({
									name: keys[i],
									intermediate: keys[i],
									new_name: keys[i],
								});
							}
						}
					}
				}
				if (this.data.length > 0) {
					for (var i = 0; i < this.columns.length; i++) {
						if (this.columns[i].name !== this.columns[i].new_name) {
							for (var j = 0; j < this.data.length; j++) {
								if (
									this.data[j].hasOwnProperty(
										this.columns[i].name
									)
								) {
									this.data[j][this.columns[i].new_name] =
										this.data[j][this.columns[i].name];
									delete this.data[j][this.columns[i].name];
								}
							}
						}
					}
				}
				this.$emit("update", this.dataset_id, this.data);
			},
			async updateType() {
				if (this.type == "db") this.$refs.set.init(this.table);
			},
			async updateTable() {
				var self = this;

				self.$nextTick(function () {
					self.$refs.set.init(self.table);
				});
			},
		},
		mounted: async function () {
			let response = await users.getSelf(true);
			this.client = response.client;
			var tables = [];
			if (this.client.details && this.client.details.tables)
				tables = this.client.details.tables;

			if (tables && tables.length > 0) {
				for (var i = 0; i < tables.length; i++) {
					this.tables.push(tables[i].name);
				}
			}
		},
	};
</script>
